import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { CountryChipItem } from "@similarweb/ui-components";

import type { ICountry } from "app/components/filters-bar/country-filter/CountryFilterTypes";

const { midnight } = colorsPalettes;
const Container = styled.div`
    .SWReactIcons {
        display: flex;
        justify-content: center;
        align-items: center;
        & svg path {
            fill: ${midnight[100]};
        }

        &[data-automation-icon-name="arrow"] svg {
            width: 10px;
            height: 5px;
        }
    }
`;

export const renderButtonComponent = (selectedCountry: ICountry) => {
    return (
        <Container>
            <CountryChipItem
                id={selectedCountry.id}
                text={selectedCountry.text}
                actionIconName={"arrow"}
            />
        </Container>
    );
};
